import $ from 'jquery';
import { $Elements, Elements, Events, Classes, Durations } from './constants';
import { disableBodyScroll, scrollTo, enableBodyScroll } from './helpers';
import { throttle } from 'throttle-debounce';

$Elements.document.on(Events.page.enter, () => {

	// ---------- Menu ----------

	$('.menu-toggle, a[href="#menu-wrapper"]').on('click', function(e) {
		e.preventDefault();

		if($Elements.body.hasClass(Classes.menuOpen)) {
			$Elements.body.removeClass(Classes.menuOpen);
		}
		else {
			const active = $Elements.MenuWrapper.find('.main-menu li[data-menu="' + Elements.PageWrapper.dataset.activeMenu + '"]').last();

			if(active.hasClass('submenu-item') && !$Elements.MenuWrapper.find('.menu-image.active').length) {

				const image = active.prevAll('.menu-item').first().data('menu');
				$Elements.MenuWrapper.find('.menu-image[data-menu="' + image + '"]').addClass(Classes.active);
			}

			active.trigger('mouseenter');
			$Elements.body.addClass(Classes.menuOpen);
		}
	});

	$('.menu-overlay').on('click', function(e) {
		e.preventDefault();

		$('.menu-toggle').trigger('click');
	});

	$Elements.MenuWrapper.each(function() {

		const images = $(this).find('.menu-images');
		const menuImages = images.find('.menu-image');
		const links = $(this).find('.menu-links');
		const menuItems = links.find('.menu-item');


		menuItems.on('mouseenter touchstart', throttle(Durations.default.ms, false, async function() {
			Elements.MainWrapper.dataset.activeMenu = this.dataset.menu;

			menuItems.removeClass(Classes.active);
			this.classList.add(Classes.active);

			const leaving = images.find('.' + Classes.active);
			const active = images.find('.menu-image[data-menu="' + this.dataset.menu + '"]');

			if(leaving.length && active.length && !leaving[0].isSameNode(active[0])) {

				leaving.removeClass(Classes.active);
				active.addClass(Classes.active);

			}
		}));
	});

	$Elements.window.on('load', function() {

		const linkTarget = window.location.href;
		const sectionTarget = linkTarget.substring(linkTarget.lastIndexOf('#'), linkTarget.length);

		if(sectionTarget.substring(0, 1) === '#') {

			const section = $(sectionTarget);

			if(section.length) {
				scrollTo(section, 0);
			}
		}
	});
});
